//// Application Configuration

//// Application Packages

//// Application Slices

//// Application Components

//// Carbon Components

//// Carbon Icons

//// Static Constants

// Extract Data (Utility)
export const extractSubmissionPage = async (digital_name, accountData) => {
    try {
        if (digital_name && accountData) {
            const names = Object?.keys(accountData)
            const pages = Object?.values(accountData)
            if (names?.length > 0 && pages?.length > 0) {
                if (digital_name === 'temporary-password') {
                    const loginIndex = names?.indexOf('login')
                    const accountIndex = names?.indexOf(digital_name)
                    if (loginIndex > -1 && accountIndex > -1) {
                        // Extract Login & Account Values
                        const login = pages[loginIndex]
                        const account = pages[accountIndex]

                        // Combine Login & Account Values
                        const values = {
                            ...login?.values,
                            ...account?.values,
                        }

                        // Check For Values
                        if (values) {
                            //// Start Update Data ////

                            return values

                            //// End Update Data ////
                        } else {
                            return null
                        }
                    } else {
                        return null
                    }
                } else {
                    const index = names?.indexOf(digital_name)
                    if (index > -1) {
                        const { values, auxiliary } = pages[index]

                        // Check For Values
                        if (values) {
                            //// Start Update Data ////

                            if (digital_name === 'registration') {
                                // Check For Auxiliary
                                if (auxiliary?.['checked']) {
                                    // Check For Values Of Email And Missing Values Of UserID
                                    if (
                                        values?.['Email'] &&
                                        !values?.['UserID']
                                    ) {
                                        const update = {}
                                        update.values = values
                                        update.values = await {
                                            ...update?.values,
                                            UserID: values?.Email,
                                        }
                                        // Check For Updated Values Of UserID
                                        if (update?.['values']?.['UserID']) {
                                            return update?.values
                                        } else {
                                            return values
                                        }
                                    } else {
                                        return values
                                    }
                                } else {
                                    return values
                                }
                            } else {
                                return values
                            }

                            //// End Update Data ////
                        } else {
                            return null
                        }
                    } else {
                        return null
                    }
                }
            } else {
                return null
            }
        } else {
            return null
        }
    } catch (error) {
        console.warn('Extract Submission Page Error:', error)
        return null
    }
}
